import $ from 'jquery';
import {isJson, toggleCloudCurrency} from '../helpers';
import { isBool } from 'scrambling-letters/js/scrambleUtil'
const {__, _x, _n, _nx} = wp.i18n;

class Vps {
    constructor() {
        this.orderForm = document.querySelector('.gf-vps');

        if (!this.orderForm) return;

        this.orderFiled = $('.gf-vps__order input');
        this.stateField = $('.gf-vps__state input');
        this.mnemoName = $('.gf-vps__mnemoname input').val();
        this.vps = [];
        this.isRu = $('.gf-vps--ru');
        this.isEu = $('.gf-vps--eu');
        this.panel = this.orderForm.querySelector('.gf-vps__panel select');
        this.sysAdmin = this.orderForm.querySelector('.gf-vps__sysadmin select');

        this.customBackupField = document.querySelector('.gf-vps__cloud-custom input');

        this.currencyRubTranslated = 'руб.';
        this.currencyEuroTranslated = 'евро';

        this.currency = this.isRu ? 'RUB' : 'EUR';
        this.messagePrice = 0;

        this.init();
        this.events();
    }

    init() {
        this.formatPanelSysAdminSelect();
        this.parseUrl();
    }

    events() {
        this.orderForm.addEventListener('change', this.periodHandler.bind(this))
        gform.addAction('gform_input_change', this.createOrder.bind(this));
        if (this.customBackupField) {
            this.customBackupField.addEventListener('focusout', this.customBackupFieldHandler.bind(this))
        }
    }

    parseUrl() {
        const queryValue = new URLSearchParams(window.location.search).get('storage');
        if (!queryValue) return false;
        const cloudOptions = this.orderForm.querySelectorAll('.gf-vps__cloud option')

        cloudOptions.forEach(option => {
            const optionValue = isJson(option.value) ? JSON.parse(option.value).volume : option.value;

            if (optionValue === queryValue) {
                option.setAttribute('selected', 'selected')
            }

        })

    }

    customBackupFieldHandler() {
        let cloudBackupMinValue = $('.gf-vps__cloud:visible option:first-child').val();
        const cloudBackupCustomField = $('.gf-vps__cloud-custom:visible input');
        if (typeof cloudBackupMinValue !== 'undefined') {
            cloudBackupMinValue = JSON.parse(cloudBackupMinValue)
            cloudBackupCustomField.attr('min', cloudBackupMinValue.volume);

            if (+cloudBackupCustomField.val() < +cloudBackupMinValue.volume) {
                cloudBackupCustomField.val(cloudBackupMinValue.volume)
                this.vps[0].storage.volume = cloudBackupMinValue.volume;
                this.vps[0].storage.price = cloudBackupMinValue.volume * 1;
            }
        }

        this.orderFiled.val(JSON.stringify(this.vps))
    }

    translate() {

        if (ATLEX_OBJ.lang === 'ru') {
            this.currencyRubTranslated = 'руб.';
            this.currencyEuroTranslated = 'евро.';
        } else if (ATLEX_OBJ.lang === 'en') {
            this.currencyRubTranslated = 'rubles';
            this.currencyEuroTranslated = 'euro';
        }
    }

    calcPriceRUB(orderForm) {

        const vpsPrices = orderForm.find('.ginput_product_price');
        const isCurrencyRub = $('.gf-vps__currency input').is(':checked');

        // Все цены
        vpsPrices.filter((id, item) => {
            let price = +$(item).next('input').val().replace(/\s+/g, '');
            if (!Number.isNaN(price)) {
                if (this.isEu.length) {
                    if (isCurrencyRub) {
                        if (!Number.isNaN(price)) {
                            price = Math.round(price * ATLEX_OBJ.exchange_rate.eur);
                            $(item).text(price.toLocaleString('ru-RU') + ` ${this.currencyRubTranslated}`)
                        }
                    } else {
                        $(item).text(price.toLocaleString('en-GB') + ` ${this.currencyEuroTranslated}`)
                    }
                } else if (this.isRu.length) {
                    $(item).text(price.toLocaleString('ru-RU') + ` ${this.currencyRubTranslated}`)
                }
            }
        })

        // Облако
        if (this.isEu.length) {
            toggleCloudCurrency('vps')
        }

    }

    calcTotalPrice(vpsPrice, ipPrice, ipQty, panelPrice, sysAdminPrice) {

        const totalPrice = vpsPrice + (ipPrice * ipQty) + panelPrice + sysAdminPrice;

        setTimeout(() => {
            const totalPriceSpan = $('.gf-vps__price-total span');

            if (this.isRu.length) {
                totalPriceSpan.text(totalPrice.toLocaleString('ru-RU') + `  ${this.currencyRubTranslated}`);
            } else if (this.isEu.length) {
                const isCurrencyRub = $('.gf-vps__currency input').is(':checked');
                if (isCurrencyRub) {
                    totalPriceSpan.text((Math.round(totalPrice * ATLEX_OBJ.exchange_rate.eur)).toLocaleString('ru-RU') + `  ${this.currencyRubTranslated}`);
                    this.currency = 'RUB';
                } else {
                    totalPriceSpan.text(totalPrice.toLocaleString('en-GB') + ` ${this.currencyEuroTranslated}`);
                    this.currency = 'EUR';
                }

            }
        }, 1)

        return totalPrice;
    }

    createOrder(elem, formId, fieldId) {
        const orderForm = $('.gf-vps');

        if (!orderForm.length) return false;

        this.translate();

        this.calcPriceRUB(orderForm);

        // let currency = this.currency,
        let currency = this.isRu.length ? 'RUB' : 'EUR',
            vpsField = $('.gf-vps__title:visible'),
            periodField = $('.gf-vps__period'),
            osField = $('.gf-vps__os:visible'),
            isoField = $('.gf-vps__iso:visible'),

            title = vpsField.find('label').text(),

            period = this.isRu.length
                ? parseInt(periodField.find('option:selected').text())
                : parseFloat(periodField.find('option:selected').text()),
            periodArr = periodField.find('option:selected').text().split(' '),
            osID = osField.find('option:selected').val(),
            region = this.isRu.length ? 1 : 2;

        if (osID === 'myself') {
            osID = isoField.find('option:selected').val()
        }

        let vpsPrice;

        if (vpsField.length) {
            vpsPrice = this.isRu.length
                ? parseInt(vpsField.find('.ginput_product_price').next('input').val().replace(/\s+/g, ''))
                : parseFloat(vpsField.find('.ginput_product_price').next('input').val().replace(/[ ,]/g, ""))
        }

        // Облако для бэкапа
        const cloudBackupField = $('.gf-vps__cloud:visible option:selected');
        const cloudBackupCustomField = $('.gf-vps__cloud-custom:visible input');

        let cloudBackup;

        if (cloudBackupField.val() === 'another') {
            cloudBackup = {
                volume: cloudBackupCustomField.val(),
                price: cloudBackupCustomField.val() * 1,
                currency: "RUB",
                unit: "ГБ"
            }
        } else {
            cloudBackup = cloudBackupField.val()
                ? JSON.parse(cloudBackupField.val())
                : {volume: "", price: "0", currency: "RUB", unit: ""};

        }

        let postfix = '-hvm';
        const isIso = $('.gf-vps__os option:selected').val() === 'myself';

        this.vps = [
            {
                osid: osID,
                aclassid: 11,
                period: periodArr[0],
                name: isIso ? title + postfix.toUpperCase() : title,
                ordermnemoname: isIso ? this.mnemoName + postfix : this.mnemoName,
                region: region,
                license: 'no',
                price: vpsPrice,
                currency,
            },
        ];

        if (cloudBackup.volume) {
            this.vps[0]['storage'] = {
                volume: cloudBackup.volume,
                unit: cloudBackup.unit,
                price: cloudBackup.price,
                currency: cloudBackup.currency
            }
        }

        const ipField = $('.gf-vps__ip-price:visible');
        let ipQty = +$('.gf-vps__ip-qty:visible').find('input').val();
        let ipPrice = 0;
        if (ipQty !== 0) {

            if (ipField.length) {
                ipPrice = this.isRu.length
                    ? parseInt(ipField.find('.ginput_product_price').next('input').val().replace(/\s+/g, ''))
                    : parseFloat(ipField.find('.ginput_product_price').next('input').val().replace(/\s+/g, ''));
            }

            let ipItem = {
                aclassid: 4,
                period,
                name: 'Дополнительный IP-адрес',
                ordermnemoname: 'alternate-ip-address',
                price: ipPrice * ipQty,
                currency,
                region: region,
                numberofitems: ipQty
            }

            this.vps.push(ipItem);
        }

        const selectedPanel = this.panel?.options[this.panel.selectedIndex];
        const mnemoname = selectedPanel?.dataset.mnemoname;

        let panel = {};

        if(mnemoname !== 'false') {
            panel = {
                aclassid: 10020,
                ordermnemoname: mnemoname,
                name: selectedPanel.dataset.name,
                price: selectedPanel.dataset.price * period,
                currency: currency,
                region: region,
                period: period,
            }

            this.vps.push(panel);
        }

        const panelPrice = panel.price ? +panel.price : 0;


        const selectedSysadmin = this.sysAdmin?.options[this.sysAdmin.selectedIndex];
        const sysAdminMnemoname = selectedSysadmin?.dataset.mnemoname;

        let sysAdmin = {};

        if(sysAdminMnemoname !== 'false' && typeof sysAdminMnemoname !== 'undefined') {
            sysAdmin = {
                aclassid: 10017,
                ordermnemoname: sysAdminMnemoname,
                name: selectedSysadmin?.dataset.name,
                price: selectedSysadmin?.dataset.price * period,
                currency: currency,
                region: region,
                period: period,
            }

            this.vps.push(sysAdmin);
        }

        const sysAdminPrice = sysAdmin.price ? +sysAdmin.price : 0;

        const totalPrice = this.calcTotalPrice(vpsPrice, ipPrice, ipQty, panelPrice, sysAdminPrice);
        /**
         * Google Analytics
         */
        const $gaTotalPriceField = (currency === 'RUB')
            ? $('.gf-vps--ru .gf-vps__ga-total-price input')
            : $('.gf-vps--eu .gf-vps__ga-total-price input')

        /**
         * @var ATLEX_OBJ global
         */

        if (currency === 'RUB') {
            $gaTotalPriceField.val(parseInt(totalPrice) + parseInt(cloudBackup.price) + parseInt(this.messagePrice))
        } else {
            $gaTotalPriceField.val((totalPrice * ATLEX_OBJ.exchange_rate.eur) + parseFloat(cloudBackup.price) + parseFloat(this.messagePrice))
        }

        this.stateField.val(JSON.stringify(this.vps));

        this.orderFiled.val(JSON.stringify(this.vps));

    }

    formatPanelSysAdminSelect(e) {
        if(!this.panel) {
            return false;
        }

        const isEvent = Boolean(e);
        const currency = this.orderForm.classList.contains('gf-vps--ru') ? __('руб.', 'atlex') : __('евро', 'atlex');
        const options = [...this.panel?.querySelectorAll('option') || [], ...this.sysAdmin?.querySelectorAll('option') || []];

        const [periodField] = Array.from(this.orderForm.querySelectorAll('.gf-vps__period')).filter(field => {
          return field.style.display !== 'none'
        });

        const periodSelect = periodField.querySelector('select');
        const period = parseInt(periodSelect.options[periodSelect.selectedIndex].textContent);

        options.forEach(option => {
           let [mnemoname, name, price] = option.value.split('|');

           if(!isEvent) {
               option.setAttribute('data-mnemoname', mnemoname);
               option.setAttribute('data-name', name);
               option.setAttribute('data-price', price);
           }

           price = +option.dataset.price * period;

           option.value = `${option.dataset.name}|${price}`;
           option.textContent = `${option.dataset.name} ${price ? '(' + price + ' ' + currency + ')' : ''}`;
        });
    }

    periodHandler(e) {
        const isPeriodChangeEvent = e && e.type === 'change' && e.target.closest('.gf-vps__period');
        if(!isPeriodChangeEvent){
            return false;
        }

        this.formatPanelSysAdminSelect(e);
    }
}

export default Vps;
